// export const GOOGLE_RECAPTCHA_SITE_KEY      = "6LdjWSgqAAAAACPsLSjrrkhn0tA36r2yHONXpBsr";
// export const GOOGLE_RECAPTCHA_SECRET_KEY    = "6LdjWSgqAAAAAAiz7fbQYxhsII-ZIuFzixHKbx3g";

export const GOOGLE_RECAPTCHA_SITE_KEY      = "6Ldf4ygqAAAAAPRc6RUamfPyvSMIZqio4t7Z7pDw";
export const GOOGLE_RECAPTCHA_SECRET_KEY    = "6Ldf4ygqAAAAACazQlEP_kJCJ45AwLg5SMfy8LMQ";

export const GOOGLE_OAUTH_CLIENT_ID         = "3027197740-p7hd0enan1amcnl95p9nho835t0pkeka.apps.googleusercontent.com";
export const GOOGLE_OAUTH_CLIENT_SECRET     = "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";

export const FACEBOOK_OAUTH_APP_ID          = "550956477495838";

export const URL_BACKEND = 'http://localhost:4110';
// export const URL_BACKEND = 'http://157.66.100.67:4110';
export const API_SUB_URL_AUTHENTICATE       = '/api/authenticate';
export const API_SUB_URL_USERS              = '/api/users';
export const API_SUB_URL_USER_LOG           = '/user_logs';
export const API_SUB_URL_SYSTEM_SETTING        = '/system_settings';

export const API_SUB_URL_PAYMENT    = '/payments';
export const API_SUB_URL_EXPORT_CSV_FILE       = '/export_csv_file';
export const API_SUB_URL_EXPORT_EXCEL_FILE     = '/export_excel_file';
export const API_SUB_URL_EMAIL       = '/emails';

export const NORMAL_MAX_AGE = 30*60;
export const LOGIN_MAX_AGE = 24*60*60;
export const PATIENT_INFORMATION_MAX_AGE = 1*60*60;
export const SELECTED_CLINIC_MAX_AGE = 30*24*60*60;

export const ROLES = {
    "admin": "Quyền Admin (thao tác thêm, sửa, xoá dữ liệu)",
    "normal": "Quyền User (chỉ được xem)"
};

export const ERROR_CODES = {
    "ERR_NETWORK": "Mất kết nối tới server!"
}

export const PAGINATION_LIST = [
    5, 10, 15, 25, 50, 100
]

export const CHAM_CHI_NHANH = {
    "CKB - CN1 GADL":	"Đà Lạt",
    "CKB - CN2 KHB":	"Đà Lạt",
    "CKB - CN3 PXL":	"HCM",
    "CKB - CN4 VINH":	"Nha Trang",
    "CKB - CN5 GODL":	"Đà Lạt",
    "CKB - CN6 TĐ":	    "HCM",
    "CKB - CN7 GC":	    "Nha Trang",
    "CKB - CN8 CLD":	"HCM",
}

export const AUTHORIZE_TYPES = [
    { label: "Admin", value: "admin" }, 
    { label: "Dashboard", value: "dashboard" }, 
    { label: "Import dữ liệu", value: "import_data" }, 
    { label: "Tất cả các trang", value: "all" }
];
export const IMPORT_FILE_TYPES = [
    { label: "Fabi 05", value: "fabi_05" }, 
    { label: "Vietcombank", value: "vietcombank" }, 
    { label: "Momo", value: "momo" }, 
    { label: "Vnpay", value: "vnpay" }, 
    { label: "Shopee", value: "shopee" }, 
    { label: "Grab", value: "grab" }, 
    { label: "Befood", value: "befood" }, 
    { label: "Chuyển đổi Combo", value: "combo_convert" }, 
];
export const IS_AUTHORIZED = [{ "label": "Đã xác thực", "value": true }, { "label": "Chưa xác thực", "value": false }];